export var AgentNameType;
(function (AgentNameType) {
    /** Trailblazer Community agent */
    AgentNameType["TbcType"] = "TBC";
    /** Trailhead agent */
    AgentNameType["ThType"] = "TH";
})(AgentNameType || (AgentNameType = {}));
export var AssessmentKindType;
(function (AssessmentKindType) {
    AssessmentKindType["QuizType"] = "QUIZ";
    AssessmentKindType["UnsupportedType"] = "UNSUPPORTED";
})(AssessmentKindType || (AssessmentKindType = {}));
export var AwardKindType;
(function (AwardKindType) {
    AwardKindType["EventType"] = "EVENT";
    AwardKindType["ModuleType"] = "MODULE";
    AwardKindType["OtherType"] = "OTHER";
    AwardKindType["ProjectType"] = "PROJECT";
    AwardKindType["StandaloneType"] = "STANDALONE";
    AwardKindType["SuperbadgeType"] = "SUPERBADGE";
})(AwardKindType || (AwardKindType = {}));
export var BadgeKindType;
(function (BadgeKindType) {
    BadgeKindType["ModuleType"] = "MODULE";
    BadgeKindType["ProjectType"] = "PROJECT";
})(BadgeKindType || (BadgeKindType = {}));
export var CaseFilterInputType;
(function (CaseFilterInputType) {
    CaseFilterInputType["ClosedType"] = "CLOSED";
    CaseFilterInputType["OpenType"] = "OPEN";
})(CaseFilterInputType || (CaseFilterInputType = {}));
export var CaseSortFieldType;
(function (CaseSortFieldType) {
    CaseSortFieldType["CaseNumberType"] = "caseNumber";
    CaseSortFieldType["ContactNameType"] = "contactName";
    CaseSortFieldType["LastModifiedDateType"] = "lastModifiedDate";
    CaseSortFieldType["SubjectType"] = "subject";
})(CaseSortFieldType || (CaseSortFieldType = {}));
export var CaseStatusInputType;
(function (CaseStatusInputType) {
    CaseStatusInputType["CloseType"] = "CLOSE";
    CaseStatusInputType["OpenType"] = "OPEN";
})(CaseStatusInputType || (CaseStatusInputType = {}));
export var CaseSummaryStatusType;
(function (CaseSummaryStatusType) {
    CaseSummaryStatusType["CallMeetingScheduledType"] = "CALL_MEETING_SCHEDULED";
    CaseSummaryStatusType["ClosedType"] = "CLOSED";
    CaseSummaryStatusType["NeedMoreInformationType"] = "NEED_MORE_INFORMATION";
    CaseSummaryStatusType["NewType"] = "NEW";
    CaseSummaryStatusType["SolutionProvidedType"] = "SOLUTION_PROVIDED";
    CaseSummaryStatusType["UnknownType"] = "UNKNOWN";
    CaseSummaryStatusType["WaitingForCustomerType"] = "WAITING_FOR_CUSTOMER";
    CaseSummaryStatusType["WorkingType"] = "WORKING";
})(CaseSummaryStatusType || (CaseSummaryStatusType = {}));
export var CategoryRelationType;
(function (CategoryRelationType) {
    CategoryRelationType["ExclusiveType"] = "exclusive";
    CategoryRelationType["IndependentType"] = "independent";
})(CategoryRelationType || (CategoryRelationType = {}));
export var CertificationStatusEnumType;
(function (CertificationStatusEnumType) {
    CertificationStatusEnumType["ActiveType"] = "ACTIVE";
    CertificationStatusEnumType["ExpiredType"] = "EXPIRED";
    CertificationStatusEnumType["ExpiresSoonType"] = "EXPIRES_SOON";
    CertificationStatusEnumType["MaintenanceDueType"] = "MAINTENANCE_DUE";
    CertificationStatusEnumType["RetiredType"] = "RETIRED";
})(CertificationStatusEnumType || (CertificationStatusEnumType = {}));
export var ChannelType;
(function (ChannelType) {
    ChannelType["ApiType"] = "API";
    ChannelType["MobileType"] = "MOBILE";
    ChannelType["WebType"] = "WEB";
})(ChannelType || (ChannelType = {}));
export var ContentKindType;
(function (ContentKindType) {
    ContentKindType["BadgeType"] = "BADGE";
    /** @deprecated Deprecated, please use ContentKind.POST instead. */
    ContentKindType["CommunityPostType"] = "COMMUNITY_POST";
    /** @deprecated Deprecated, please use ContentKind.QUESTION instead. */
    ContentKindType["CommunityQuestionType"] = "COMMUNITY_QUESTION";
    ContentKindType["GroupType"] = "GROUP";
    ContentKindType["LearningpathType"] = "LEARNINGPATH";
    ContentKindType["LinkType"] = "LINK";
    ContentKindType["ModuleType"] = "MODULE";
    ContentKindType["PostType"] = "POST";
    ContentKindType["ProjectType"] = "PROJECT";
    ContentKindType["QuestionType"] = "QUESTION";
    ContentKindType["StepType"] = "STEP";
    ContentKindType["SuperbadgeType"] = "SUPERBADGE";
    ContentKindType["TaskType"] = "TASK";
    ContentKindType["TopicType"] = "TOPIC";
    ContentKindType["TrailType"] = "TRAIL";
    ContentKindType["TrailmixType"] = "TRAILMIX";
    ContentKindType["UnitType"] = "UNIT";
})(ContentKindType || (ContentKindType = {}));
export var ContentSortFieldType;
(function (ContentSortFieldType) {
    ContentSortFieldType["FirstPublishedAtType"] = "first_published_at";
    ContentSortFieldType["MinuteTotalType"] = "minute_total";
    ContentSortFieldType["PointTotalType"] = "point_total";
    ContentSortFieldType["TitleType"] = "title";
})(ContentSortFieldType || (ContentSortFieldType = {}));
export var ContentTypeEnumType;
(function (ContentTypeEnumType) {
    ContentTypeEnumType["ModuleContentType"] = "module_content";
    ContentTypeEnumType["ProjectContentType"] = "project_content";
    ContentTypeEnumType["TrailType"] = "trail";
})(ContentTypeEnumType || (ContentTypeEnumType = {}));
export var DynamicValueSourceType;
(function (DynamicValueSourceType) {
    DynamicValueSourceType["ApiNameType"] = "api_name";
    DynamicValueSourceType["NameType"] = "name";
})(DynamicValueSourceType || (DynamicValueSourceType = {}));
export var ErrorKindType;
(function (ErrorKindType) {
    ErrorKindType["ClientErrorType"] = "CLIENT_ERROR";
    ErrorKindType["NothingType"] = "NOTHING";
    ErrorKindType["NotFoundType"] = "NOT_FOUND";
    ErrorKindType["QuizSubmissionType"] = "QUIZ_SUBMISSION";
    ErrorKindType["ServiceErrorType"] = "SERVICE_ERROR";
    ErrorKindType["TimeoutType"] = "TIMEOUT";
    ErrorKindType["UnauthorizedType"] = "UNAUTHORIZED";
})(ErrorKindType || (ErrorKindType = {}));
export var ExperienceSourceType;
(function (ExperienceSourceType) {
    ExperienceSourceType["AndroidType"] = "android";
    ExperienceSourceType["IosType"] = "ios";
    ExperienceSourceType["SlackType"] = "slack";
    ExperienceSourceType["WebType"] = "web";
})(ExperienceSourceType || (ExperienceSourceType = {}));
export var FilterTypeEnumType;
(function (FilterTypeEnumType) {
    FilterTypeEnumType["ModuleType"] = "MODULE";
    FilterTypeEnumType["ProjectType"] = "PROJECT";
    FilterTypeEnumType["SuperbadgeType"] = "SUPERBADGE";
})(FilterTypeEnumType || (FilterTypeEnumType = {}));
export var InProgressBadgesFilterTypeEnumType;
(function (InProgressBadgesFilterTypeEnumType) {
    InProgressBadgesFilterTypeEnumType["ModuleType"] = "MODULE";
    InProgressBadgesFilterTypeEnumType["ProjectType"] = "PROJECT";
    InProgressBadgesFilterTypeEnumType["SuperbadgeType"] = "SUPERBADGE";
})(InProgressBadgesFilterTypeEnumType || (InProgressBadgesFilterTypeEnumType = {}));
export var ItemTypeEnumType;
(function (ItemTypeEnumType) {
    ItemTypeEnumType["BadgeType"] = "BADGE";
    ItemTypeEnumType["CollaborationGroupType"] = "COLLABORATION_GROUP";
    ItemTypeEnumType["FeedItemPostType"] = "FEED_ITEM_POST";
    ItemTypeEnumType["FeedItemQuestionType"] = "FEED_ITEM_QUESTION";
    ItemTypeEnumType["HelpDocsType"] = "HELP_DOCS";
    ItemTypeEnumType["HtDeveloperDocumentsCType"] = "HT_DEVELOPER_DOCUMENTS_C";
    ItemTypeEnumType["HtReleaseNotesDocumentationCType"] = "HT_RELEASE_NOTES_DOCUMENTATION_C";
    ItemTypeEnumType["KbGettingStartedType"] = "KB_GETTING_STARTED";
    ItemTypeEnumType["KbKnowledgeArticleType"] = "KB_KNOWLEDGE_ARTICLE";
    ItemTypeEnumType["KbQuickStartsType"] = "KB_QUICK_STARTS";
    ItemTypeEnumType["KnownIssueCType"] = "KNOWN_ISSUE_C";
    ItemTypeEnumType["LearningpathType"] = "LEARNINGPATH";
    ItemTypeEnumType["LinkType"] = "LINK";
    ItemTypeEnumType["ListingCType"] = "LISTING_C";
    ItemTypeEnumType["ModuleType"] = "MODULE";
    ItemTypeEnumType["ProjectType"] = "PROJECT";
    ItemTypeEnumType["StepType"] = "STEP";
    ItemTypeEnumType["SuperbadgeType"] = "SUPERBADGE";
    ItemTypeEnumType["TaskType"] = "TASK";
    ItemTypeEnumType["ThKnowledgeType"] = "TH_KNOWLEDGE";
    ItemTypeEnumType["TopicType"] = "TOPIC";
    ItemTypeEnumType["TrailType"] = "TRAIL";
    ItemTypeEnumType["TrailheadType"] = "TRAILHEAD";
    ItemTypeEnumType["TrailmixType"] = "TRAILMIX";
    ItemTypeEnumType["UnitType"] = "UNIT";
    ItemTypeEnumType["UserType"] = "USER";
    ItemTypeEnumType["VideoType"] = "VIDEO";
})(ItemTypeEnumType || (ItemTypeEnumType = {}));
export var LearningFilterKindType;
(function (LearningFilterKindType) {
    /** @deprecated This field is no longer being exposed. */
    LearningFilterKindType["LearnedSkillType"] = "LEARNED_SKILL";
    LearningFilterKindType["LevelType"] = "LEVEL";
    LearningFilterKindType["ProductType"] = "PRODUCT";
    LearningFilterKindType["RoleType"] = "ROLE";
    /** @deprecated This field is no longer being exposed. */
    LearningFilterKindType["SkillType"] = "SKILL";
})(LearningFilterKindType || (LearningFilterKindType = {}));
export var LearningKindType;
(function (LearningKindType) {
    LearningKindType["BadgeType"] = "BADGE";
    LearningKindType["LearningpathType"] = "LEARNINGPATH";
    LearningKindType["LinkType"] = "LINK";
    LearningKindType["ModuleType"] = "MODULE";
    LearningKindType["ProjectType"] = "PROJECT";
    LearningKindType["StepType"] = "STEP";
    LearningKindType["SuperbadgeType"] = "SUPERBADGE";
    LearningKindType["TaskType"] = "TASK";
    LearningKindType["TrailType"] = "TRAIL";
    LearningKindType["TrailmixType"] = "TRAILMIX";
    LearningKindType["UnitType"] = "UNIT";
})(LearningKindType || (LearningKindType = {}));
export var LearningPathLevelType;
(function (LearningPathLevelType) {
    LearningPathLevelType["LearningpathType"] = "LEARNINGPATH";
    LearningPathLevelType["MilestoneType"] = "MILESTONE";
    LearningPathLevelType["StepType"] = "STEP";
})(LearningPathLevelType || (LearningPathLevelType = {}));
export var MobileServiceTypeInputType;
(function (MobileServiceTypeInputType) {
    MobileServiceTypeInputType["AndroidType"] = "ANDROID";
    MobileServiceTypeInputType["AppleType"] = "APPLE";
})(MobileServiceTypeInputType || (MobileServiceTypeInputType = {}));
export var NotificationType;
(function (NotificationType) {
    NotificationType["PushType"] = "PUSH";
    NotificationType["ReminderType"] = "REMINDER";
    NotificationType["SlackType"] = "SLACK";
})(NotificationType || (NotificationType = {}));
export var NotificationContextType;
(function (NotificationContextType) {
    NotificationContextType["AbandonModuleReminderType"] = "ABANDON_MODULE_REMINDER";
})(NotificationContextType || (NotificationContextType = {}));
export var OperatorType;
(function (OperatorType) {
    OperatorType["AndType"] = "AND";
    OperatorType["OrType"] = "OR";
})(OperatorType || (OperatorType = {}));
export var PopularContentTypeKindType;
(function (PopularContentTypeKindType) {
    PopularContentTypeKindType["BadgeType"] = "badge";
    PopularContentTypeKindType["TrailType"] = "trail";
})(PopularContentTypeKindType || (PopularContentTypeKindType = {}));
export var ProgressType;
(function (ProgressType) {
    ProgressType["AllType"] = "ALL";
    ProgressType["CompletedType"] = "COMPLETED";
    ProgressType["IncompleteType"] = "INCOMPLETE";
})(ProgressType || (ProgressType = {}));
export var RecommendationAnchorKindType;
(function (RecommendationAnchorKindType) {
    /** Recommendations based on a given module */
    RecommendationAnchorKindType["ItemType"] = "ITEM";
    /** Recommendations based on a given level tag */
    RecommendationAnchorKindType["LevelType"] = "LEVEL";
    /** Recommendations based on a given product tag */
    RecommendationAnchorKindType["ProductType"] = "PRODUCT";
    /** Recommendations based on a given role tag */
    RecommendationAnchorKindType["RoleType"] = "ROLE";
})(RecommendationAnchorKindType || (RecommendationAnchorKindType = {}));
export var RecommendationExperienceSourceType;
(function (RecommendationExperienceSourceType) {
    RecommendationExperienceSourceType["AndroidType"] = "android";
    RecommendationExperienceSourceType["IosType"] = "ios";
    RecommendationExperienceSourceType["SlackType"] = "slack";
    RecommendationExperienceSourceType["TrailheadWebType"] = "trailhead_web";
})(RecommendationExperienceSourceType || (RecommendationExperienceSourceType = {}));
export var RecommendationGroupedByType;
(function (RecommendationGroupedByType) {
    /** Recommendations by popular modules */
    RecommendationGroupedByType["PopularModulesType"] = "POPULAR_MODULES";
    /** Recommendations by a users' recent activity */
    RecommendationGroupedByType["RecentActivityType"] = "RECENT_ACTIVITY";
    /** Recommendations by a users' completed modules */
    RecommendationGroupedByType["RoleRulesBasedType"] = "ROLE_RULES_BASED";
    /** Recommendations by a users' completed tags, products */
    RecommendationGroupedByType["SkillType"] = "SKILL";
})(RecommendationGroupedByType || (RecommendationGroupedByType = {}));
export var SearchDirectionType;
(function (SearchDirectionType) {
    SearchDirectionType["AscType"] = "ASC";
    SearchDirectionType["DescType"] = "DESC";
})(SearchDirectionType || (SearchDirectionType = {}));
export var SearchEventType;
(function (SearchEventType) {
    SearchEventType["ClickType"] = "CLICK";
    SearchEventType["FacetDeselectType"] = "FACET_DESELECT";
    SearchEventType["FacetSelectType"] = "FACET_SELECT";
    SearchEventType["PagerNextType"] = "PAGER_NEXT";
    SearchEventType["PagerPreviousType"] = "PAGER_PREVIOUS";
    SearchEventType["SortType"] = "SORT";
})(SearchEventType || (SearchEventType = {}));
export var SearchSortKindType;
(function (SearchSortKindType) {
    SearchSortKindType["MostPointsType"] = "MOST_POINTS";
    SearchSortKindType["NewestType"] = "NEWEST";
    SearchSortKindType["QuickestType"] = "QUICKEST";
    SearchSortKindType["RelevanceType"] = "RELEVANCE";
})(SearchSortKindType || (SearchSortKindType = {}));
export var SearchTabType;
(function (SearchTabType) {
    /** @deprecated No longer available */
    SearchTabType["AllType"] = "ALL";
    /** @deprecated No longer available */
    SearchTabType["CommunityType"] = "COMMUNITY";
    /** @deprecated No longer available */
    SearchTabType["DocumentationType"] = "DOCUMENTATION";
    SearchTabType["LearningType"] = "LEARNING";
})(SearchTabType || (SearchTabType = {}));
export var SortDirectionType;
(function (SortDirectionType) {
    SortDirectionType["AscType"] = "asc";
    SortDirectionType["DescType"] = "desc";
})(SortDirectionType || (SortDirectionType = {}));
export var StampKindType;
(function (StampKindType) {
    /** Event */
    StampKindType["EventInPersonType"] = "EVENT_IN_PERSON";
    /** Virtual Event */
    StampKindType["EventVirtualType"] = "EVENT_VIRTUAL";
})(StampKindType || (StampKindType = {}));
export var StateKindType;
(function (StateKindType) {
    StateKindType["AtRiskType"] = "at_risk";
    StateKindType["CompleteType"] = "complete";
    StateKindType["EncouragedType"] = "encouraged";
    StateKindType["NoneType"] = "none";
})(StateKindType || (StateKindType = {}));
export var StepType;
(function (StepType) {
    StepType["ArticleType"] = "ARTICLE";
    StepType["CertificationType"] = "CERTIFICATION";
    StepType["CommunityType"] = "COMMUNITY";
    StepType["KnowledgeCheckType"] = "KNOWLEDGE_CHECK";
    StepType["LinkType"] = "LINK";
    StepType["ThModuleType"] = "TH_MODULE";
    StepType["ThProjectType"] = "TH_PROJECT";
    StepType["ThSuperbadgeType"] = "TH_SUPERBADGE";
    StepType["VideoType"] = "VIDEO";
})(StepType || (StepType = {}));
export var TrailmixSortFieldType;
(function (TrailmixSortFieldType) {
    TrailmixSortFieldType["LabelType"] = "label";
    TrailmixSortFieldType["UpdatedAtType"] = "updated_at";
})(TrailmixSortFieldType || (TrailmixSortFieldType = {}));
export var TypeEnumType;
(function (TypeEnumType) {
    TypeEnumType["ModuleType"] = "MODULE";
    TypeEnumType["ProjectType"] = "PROJECT";
    TypeEnumType["SuperbadgeType"] = "SUPERBADGE";
    TypeEnumType["TrailType"] = "TRAIL";
})(TypeEnumType || (TypeEnumType = {}));
export var UnitProgressStateType;
(function (UnitProgressStateType) {
    UnitProgressStateType["CompletedType"] = "COMPLETED";
    UnitProgressStateType["InProgressType"] = "IN_PROGRESS";
    UnitProgressStateType["NotStartedType"] = "NOT_STARTED";
})(UnitProgressStateType || (UnitProgressStateType = {}));
export var UserProgressStateType;
(function (UserProgressStateType) {
    UserProgressStateType["CompletedType"] = "COMPLETED";
    UserProgressStateType["InProgressType"] = "IN_PROGRESS";
    UserProgressStateType["NotStartedType"] = "NOT_STARTED";
})(UserProgressStateType || (UserProgressStateType = {}));
export var UserRenewalStatusType;
(function (UserRenewalStatusType) {
    UserRenewalStatusType["NewType"] = "NEW";
})(UserRenewalStatusType || (UserRenewalStatusType = {}));
export var UserTrailRenewalStatusType;
(function (UserTrailRenewalStatusType) {
    UserTrailRenewalStatusType["CompletedType"] = "COMPLETED";
    UserTrailRenewalStatusType["InProgressType"] = "IN_PROGRESS";
    UserTrailRenewalStatusType["NewType"] = "NEW";
})(UserTrailRenewalStatusType || (UserTrailRenewalStatusType = {}));
export var UxEventKeyType;
(function (UxEventKeyType) {
    UxEventKeyType["AccountConnectedType"] = "ACCOUNT_CONNECTED";
    UxEventKeyType["AccountConnectionPromptedType"] = "ACCOUNT_CONNECTION_PROMPTED";
    UxEventKeyType["AccountDisconnectedType"] = "ACCOUNT_DISCONNECTED";
    UxEventKeyType["CommunityInboxClickedType"] = "COMMUNITY_INBOX_CLICKED";
    UxEventKeyType["DeepLinkLoadedType"] = "DEEP_LINK_LOADED";
    UxEventKeyType["EarnMoreBadgesTappedType"] = "EARN_MORE_BADGES_TAPPED";
    UxEventKeyType["ExecuteSearchTappedType"] = "EXECUTE_SEARCH_TAPPED";
    UxEventKeyType["ExploreTrailheadTappedType"] = "EXPLORE_TRAILHEAD_TAPPED";
    UxEventKeyType["FaqTappedType"] = "FAQ_TAPPED";
    UxEventKeyType["FavoritedType"] = "FAVORITED";
    UxEventKeyType["FeatureCardTappedType"] = "FEATURE_CARD_TAPPED";
    UxEventKeyType["HelpRequestedType"] = "HELP_REQUESTED";
    UxEventKeyType["HowToSetLanguageTappedType"] = "HOW_TO_SET_LANGUAGE_TAPPED";
    UxEventKeyType["LoginTappedType"] = "LOGIN_TAPPED";
    UxEventKeyType["MfeDisplayedType"] = "MFE_DISPLAYED";
    UxEventKeyType["ProceedNextUnitTappedType"] = "PROCEED_NEXT_UNIT_TAPPED";
    UxEventKeyType["PublicHomepageViewedType"] = "PUBLIC_HOMEPAGE_VIEWED";
    UxEventKeyType["PushEnabledType"] = "PUSH_ENABLED";
    UxEventKeyType["RemindersDisabledType"] = "REMINDERS_DISABLED";
    UxEventKeyType["RemindersEnabledType"] = "REMINDERS_ENABLED";
    UxEventKeyType["SearchExecutedType"] = "SEARCH_EXECUTED";
    UxEventKeyType["SearchViewedType"] = "SEARCH_VIEWED";
    UxEventKeyType["ShareClickedType"] = "SHARE_CLICKED";
    UxEventKeyType["SwitchOrganizationTappedType"] = "SWITCH_ORGANIZATION_TAPPED";
    UxEventKeyType["SystemAppearanceTappedType"] = "SYSTEM_APPEARANCE_TAPPED";
    UxEventKeyType["TabTappedType"] = "TAB_TAPPED";
    UxEventKeyType["TodayViewedType"] = "TODAY_VIEWED";
    UxEventKeyType["TrailheadLiveViewedType"] = "TRAILHEAD_LIVE_VIEWED";
    UxEventKeyType["UnitPickerTappedType"] = "UNIT_PICKER_TAPPED";
})(UxEventKeyType || (UxEventKeyType = {}));
